/* eslint-disable @typescript-eslint/no-explicit-any */
import { DialogConfig } from '@angular/cdk/dialog';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class ModalService {
    constructor(public dialog: MatDialog) {}

    openDialog(data: any, component: any, config?: DialogConfig): Observable<any> {
        const width = config ? config.width : 'auto';
        const dialogRef = this.dialog.open(component, {
            data: data,
            autoFocus: false,
            disableClose: true,
            width
        });

        return dialogRef.afterClosed().pipe(
            map((response) => {
                return response;
            })
        );
    }
}
